import styled, { css } from 'styled-components';
import MuiTooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';

export const Wrapper = styled.div`
  .mlq {
    background-color: #f1d60a;
    display: inline-block;
    margin: 0px 3px 3px 3px;
    padding: 2px 4px;
    border-radius: 4px;
    width: 35px;
    text-align: center;
    color: #4c4f52;
  }

  .day-ago-icon {
    font-size: 18px;
  }

  .sector-empty {
    height: 36px;
  }

  .btnBack {
    margin-left: -8px;

    svg {
      font-size: 20px;
    }
  }

  .sector-item {
    box-shadow: none;
    border: 1px solid rgb(0 0 0 / 0.1);
  }

  .small-spacing {
    .MuiTable-root {
      .MuiTableRow-root {
        .MuiTableCell-root {
          padding-right: 5px;
          padding-left: 5px;

          &:first-child {
            padding-left: 0;
          }
        }
      }
    }
  }

  .sector-calendar-content {
    padding-top: 30px;

    .react-datepicker__day-names {
      display: none;
    }

    .react-datepicker {
      width: 100%;
      border: 0;
    }

    .react-datepicker__month-container {
      width: 100%;
    }

    .react-datepicker__day--outside-month {
      opacity: 0;
    }

    .react-datepicker__current-month {
      margin-bottom: 15px;
    }

    .react-datepicker__navigation {
      top: 10px;
    }

    .react-datepicker__day--selected {
      background: transparent;
    }

    .react-datepicker__day:hover,
    .react-datepicker__month-text:hover,
    .react-datepicker__quarter-text:hover,
    .react-datepicker__year-text:hover,
    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected {
      background: transparent;
    }

    .react-datepicker__day,
    .react-datepicker__day-name {
      width: calc(100% / 7 - 6px);
      cursor: default;
      height: 80px;
      display: inline-flex;
      align-items: center;
    }

    .react-datepicker__header,
    .react-datepicker__day-name {
      background: transparent;
      border: 0;
    }

    .react-datepicker__month {
      margin: 0;
    }
  }

  ${(props) => props.theme.breakpoints.down(1024)} {
    .sector-calendar-content {
      height: 350px;
      padding-top: 0;
    }

    .sector-volume-legend {
      margin-top: 45px;
    }
  }

  ${(props) => props.theme.breakpoints.down(768)} {
    .sector-calendar-content {
      height: auto;
    }

    .highlight-stockup-header {
      flex-direction: column;

      .MuiFormGroup-root {
        margin-top: 15px;
        justify-content: center;
      }

      .MuiButtonBase-root {
        padding: 6px;
      }
    }
  }

  ${(props) => props.theme.breakpoints.down(550)} {
    .cap-chart-header {
      flex-direction: column;
    }
  }

  ${(props) => props.theme.breakpoints.down(425)} {
    .page-title {
      font-size: 18px;
    }

    .tab-menu {
      max-width: calc(100vw - 24px);
      padding-bottom: 10px;
      overflow: auto;
    }
  }

  .btn-period {
    min-width: 50px;
    padding: 6px 6px;
    font-size: 12px;
    line-height: 16px;

    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ChartTooltipWrapper = styled.div`
  width: 300px;
  height: 150px;
`;

const ToBeStyledTooltip = ({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ tooltip: className }} />
);

export const Tooltip = styled(ToBeStyledTooltip)`
  &.MuiTooltip-tooltip {
    min-width: 315px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

    &.sector-trending {
      min-width: unset;
    }

    &.info {
      min-width: 355px;
    }

    &.helper {
      min-width: unset;
      max-width: 250px;
      padding: 10px 14px;
    }

    ${css`
      @media (max-width: 400px) {
        transform: scale(0.8) !important;
        margin-right: 0px !important;
      }
    `}
  }
`;

export const BootstrapDialog = styled(Dialog)`
  .MuiDialogContent-root {
    min-width: 400px;
    padding: 0 10px;
  }
  .MuiDialogActions-root {
    padding: 10px;
  }
`;

export const Icon = styled.span`
  &:hover {
    color: #791ace;
  }
`;

export const DayAgo = styled.div`
  margin-left: 8px;

  .info-icon {
    margin-left: 4px;
    font-size: 16px;
  }
`;

export const Statistics = styled.span`
  display: inline-flex;
  margin-left: 8px;

  .statistics-item {
    display: inline-flex;
    align-items: center;
    margin: 0 3px;
    line-height: 1;

    svg {
      font-size: 14px;
    }
  }
`;

export const EmptyTag = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
`;

export const LoadingWrapper = styled.div`
  padding: 15px 0;
  text-align: center;

  .MuiCircularProgress-root {
    width: 34px;
    height: 34px;
    color: #791ace;
  }
`;
